module.exports = __webpack_public_path__ + "img/danger.3b86c771.svg";